<template>
	<div id="calc" class="calculator wrapper container-fluid" @click.stop.prevent="handleClick">
		<p class="txt--xl mb--2 mb-2">
			Estimates probability that pharyngitis is streptococcal, and suggests management course – strep testing/culture/antibiotics. 
		</p>
		
		<div class="tabs mb--2">
			<nav class="tabs__nav">
				<button v-for="(tab) in tabs" v-bind:key="tab.title" role="button" class="tabs__nav-item txt--strong" :class="{ 'tabs__nav-item--active bg--primary': tab.display }" v-on:click="selectTab(tab)">
					<span v-html="tab.title"></span>
					<i v-if="!tab.display" aria-hidden="true" class="fa fa-chevron-down ml-1 ml--1 show--md"></i>
					<i v-if="tab.display" aria-hidden="true" class="fa fa-chevron-up ml-1 ml--1 show--md"></i>	
				</button>
			</nav>
			<div class="tabs__content" id="tabcontent">
				<div v-for="(tab) in tabs" v-bind:key="tab.content">
					<div v-if="tab.display" class="bdr--light-gray p--1 wysiwyg" role="tabpanel" :aria-labelledby="tab.title" v-html="tab.content"></div>
				</div>
			</div>
		</div>

		<!-- <div class="accordion bdr--light-gray accordion--arrows mb--2 hide--md">
			<div class="accordion__item bdr__top--light-gray" data-accordion-type="default" v-for="(tab, index) in tabs" v-bind:key="tab.title">
				<button :id="'tab'+index" class="accordion__header txt--md txt--strong" :class="{ 'accordion__header--active' : tab.accordion }" @click="tab.accordion = !tab.accordion">{{tab.title}}</button>
				<div :aria-labelledby="'tab'+index" class="accordion__content" :class="{ 'accordion__content--active active' : tab.accordion }" v-html="tab.content"></div>
			</div>
		</div> -->

		<div class="questions__intro-text">
			<div class="row">
				<div class="col-xs-12">
					<p>Click on the answer to each question below, then click on Calculate.</p>
				</div>
			</div>
		</div>

		<div class="row" v-for="q in questions" :key="q.id">
			<div class="col-12 col-xs-12 mb-1 mb--1">
				<div class="row" v-if='q.header != ""'>
					<div class="col-12 col-xs-12"><h2>{{q.header}}</h2></div>
				</div>
				<div class="row">
					<div class="col-12 col-xs-12 col-sm-6">
						<h3 class="txt--xl mb-1 mb--1">{{q.title}}</h3>
						<p v-html="q.info"></p>
					</div>
					<div class="col-12 col-xs-12 col-sm-6">
						<div class="list-group">
							<div v-for="o in q.options" :key="o.id">
								<button @click="optionclicked(q.id,o.id)"
										@keydown.enter="optionclicked(event, q.id,o.id)"
										type="button"
										v-bind:class="{'list-group-item list-group-item-action d-flex justify-content-between align-items-center active':(o.selected), 'list-group-item list-group-item-action d-flex justify-content-between align-items-center':(!o.selected)}">
									{{o.text}}
									<span class="badge badge-success badge-pill">{{o.value_label}}</span>
								</button>
							</div>
						</div>
					</div>
				</div>
				<hr class="mb-2 mb--2">
			</div>
		</div>
		<div id="error" class="row">
			<div class="col-12 col-xs-12">
				<div class="alert alert-info alert-informative alert--info mb-3 mb--3" role="alert" v-if="errormessage.length > 0" v-html="errormessage"></div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-xs-12">
				<div class="calculator__result bg-secondary bg--secondary p--2 p-2 mb--2 mb-2">
					<div id="calculator-copy" class="color--white text-white mb-1 mb--1" v-if="displayresult">
						<div id="result-response" v-if="isvalid"></div>
						<p v-if="result.text.length > 0 && errormessage.length == 0" class="h3 txt--xl"><strong>Summary:</strong> {{result.text}}</p>
						<h3 v-if="errormessage.length == 0"  class="h4 txt--lg"><strong>Total Centor Score</strong> : {{result.score}}</h3>
						<h3 v-if="errormessage.length > 0"  class="h4 txt--lg"><strong>Total Centor Score</strong> : N/A</h3>
						<p v-if="result.calctext.length > 0 && errormessage.length == 0" v-html="result.subtext"></p>
						<p v-if="result.text.length > 0" v-html="result.calctext"></p>
						<!-- -->
					</div>
					<div class="control-holder ">
						<button class="btn mr-1 mr--1" @click="calculateclicked" type="button" v-if="!displayresult">Calculate</button>
						<button class="btn mr-1 mr--1" type="button" @click="reset" v-if="displayresult">Reset</button>
            <button class="btn mr-1 mr--1" id="copyButton" type="button" @click="copyToClipboard" v-if="displayresult">Copy Result</button>
						<button class="btn mr-1 mr--1 hide--quris" type="button" @click="displayForm" v-if="displayresult">Email PDF</button>
					</div>
				</div>
				<div class="bg--offwhite bg-offwhite p-2 p--2" v-if="displayresult && showform">
						<p class="color--black">For security reasons, this form is only available within the NHS network. You can use it to email to an NHS email a PDF with the decision support result for this patient and then save it to the patient record.</p>
						<div class="color--black alert alert-danger alert--error mb-1 mb--1" role="alert" v-if="emailmessage.length > 0" v-html="emailmessage"></div>
						<div class="form__group mb--2">
							<label for="emailaddresses" class="form__label mb--1 txt--strong">Email addresses:</label>
							<input v-model="emailaddresses" type="text" class="form__input" name="emailaddresses" id="emailaddresses" placeholder="Enter email address(es) to receive this decision support output. NHS emails only">
						</div>
						<div class="form__group mb--2">
							<label for="patientname" class="form__label mb--1 txt--strong">Patient's Full Name:</label>
							<input v-model="patientname" type="text" class="form__input" name="patientname" id="patientname" placeholder="Enter patient’s full name">
						</div>
						<div class="form__group mb--2">
							<label for="patientchinumber" class="form__label mb--1 txt--strong">Patient CHI Number:</label>
							<input v-model="patientchinumber" type="text" class="form__input" name="patientchinumber" id="patientchinumber" placeholder="Enter patient’s CHI number">
						</div>
						<button class="btn mr-1 mr--1" type="button" @click="sendToPDF">Send</button>
					</div>
					<div class="alert alert-success alert--success mb-3 mb--3" role="alert" v-if="displayresult && !showform && emailmessage.length > 0 && emailaddresses.length > 0 && patientname.length > 0 && patientchinumber.length > 0" v-html="emailmessage"></div>
			</div>
		</div>
		<Content />
	</div>
</template>

<script>
import Content from '@/components/Content';
import "isomorphic-fetch";

export default {
	name: "Calculator",
	components: {
    Content
  },
  data() {
    return {
      emailaddresses: "",
      patientname: "",
      patientchinumber: "",
      questions: [
        {
          id: "q1",
          title: "Age",
					header: "",
          required: false,
          info: "",
          options: [
            {
              id: "o1",
              text: "3-14 years",
              value_label: "+1",
              value: 1,
              selected: false
            },
            {
              id: "o2",
              text: "15-44 years",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o3",
              text: ">= 45 years",
              value_label: "-1",
              value: -1,
              selected: false
            },
          ]
        },
        {
          id: "q2",
          title: "Exudate or swelling on tonsils ",
					header: "",
          required: false,
          info: "",
          options: [
            {
              id: "o4",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o5",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }           
          ]
        },
        {
          id: "q3",
          title: "Tender/swollen anterior or cervical lymph nodes ",
					header: "",
          required: false,
          info: "",
          options: [
            {
              id: "o6",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o7",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }           
          ]
        },
        {
          id: "q4",
          title: "Temperature above 38 degrees C (100.4 F) ",
					header: "",
          required: false,
          info: "",
          options: [
            {
              id: "o8",
              text: "No",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o9",
              text: "Yes",
              value_label: "+1",
              value: 1,
              selected: false
            }           
          ]
        },
        {
          id: "q5",
          title: "Cough",
					header: "",
          required: false,
          info: "",
          options: [
            {
              id: "o10",
              text: "Present",
              value_label: "0",
              value: 0,
              selected: false
            },
            {
              id: "o11",
              text: "Absent",
              value_label: "+1",
              value: 1,
              selected: false
            }           
          ]
        }
      ],
      result: {
        score: 0,
        calctext: "",
        text: "",
        subtext: ""
      },
      displayresult: false,
      showform: false,
      errormessage: "",
      emailmessage: "",
      isvalid: false,
      answered_count: 0,
			answer_acutechange: false,
			tabs: [
        {
          title: "When to use",
          display: false,
          accordion: false,
					content: `
						<p>Use only in patients with recent onset (3 days or less) acute pharyngitis.</p>
						<p>Most pharyngitis is viral and does not respond to antibiotic treatment. The Centor Score attempts to predict which patients will have culture-confirmed streptococcal infections of their pharynx to help determine which patients to test in the first place.</p>
            <p>The FeverPAIN Score is similar, but the Centor Score has the advantage of distinguishing adolescents and young adults from pre-adolescents. This is important because strep carrier rates are higher in preadolescents than adolescents/young adults, and older patients are more likely to have severe symptoms and develop suppurative complications.</p>
					`,
        },
        {
          title: "Evidence",
          display: false,
          accordion: false,
          content: `
						<p>The original 1981 study by <a target="_blank"  href="http://www.ncbi.nlm.nih.gov/pubmed/6763125">Centor et al</a> focused on criteria to diagnose GAS infection in adult patients presenting to the emergency department with sore throat. <a target="_blank"  href="http://www.ncbi.nlm.nih.gov/pubmed/9475915">McIsaac 1998</a> modified the Centor Score to include age. This modified score was <a href="http://jama.jamanetwork.com/article.aspx?articleid=198485" target="_blank">validated</a> in 2004 for use in both children and adults presenting with sore throat. </p>
						<p><a target="_blank" href="http://www.ncbi.nlm.nih.gov/pmc/articles/PMC3627733/">Fine et al (2012)</a> performed a national-scale validation of the score on a geographically diverse population of over 140,000 patients over the course of more than a year, mitigating any impact of seasonality of GAS incidence on the results. This analysis provided more precise interpretations of risk for each category of the Centor Score</p>
						<h4 class="txt--lg">References </h4>
						<p>Centor RM, Witherspoon JM, Dalton HP, Brody CE, Link K. The diagnosis of strep throat in adults in the emergency room. <em>Med Decis Making</em>. 1981;1(3):239-246. <a href="https://journals.sagepub.com/doi/10.1177/0272989X8100100304" target="_blank">doi:10.1177/0272989X8100100304</a></p>
						<p>McIsaac WJ, White D, Tannenbaum D, Low DE. A clinical score to reduce unnecessary antibiotic use in patients with sore throat. <em>CMAJ</em>. 1998;158(1):75-83. </p>
						<p>McIsaac WJ, Kellner JD, Aufricht P, Vanjaka A, Low DE. Empirical Validation of Guidelines for the Management of Pharyngitis in Children and Adults. <em>JAMA</em>. 2004;291(13):1587&ndash;1595. <a href="https://jamanetwork.com/journals/jama/fullarticle/198485" target="_blank">doi:10.1001/jama.291.13.1587</a></p>
						<p>Fine AM, Nizet V, Mandl KD. Large-scale validation of the Centor and McIsaac scores to predict group A streptococcal pharyngitis. <em>Arch Intern Med</em>. 2012;172(11):847-852. <a href="https://jamanetwork.com/journals/jamainternalmedicine/fullarticle/1157417" target="_blank">doi:10.1001/archinternmed.2012.950</a></p>
					`,
        },
        {
          title: "Calculation<span class='show--md'> & interpretation</span>",
          display: false,
          accordion: false,
					content: `
						<h4 class="txt--lg">Calculation</h4>
						<p>Add the selected points for each criterion:</p>
						<table class="table tbl">
							<tr>
								<th width="40%">Criteria</th>
								<th width="35%">Input value</th>
								<th align="right" width="25%">Points</th>
							</tr>
							<tr>
								<td valign="top">Age</td>
                 <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>3-14 years</td>
                      <td align="right">+1</td>
                    </tr>
                    <tr>
                      <td>15-44 years</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>>= 45 years</td>
                      <td align="right">-1</td>
                    </tr>
                  </table>
								</td>
							</tr>	
							<tr>
								<td valign="top">Exudate or swelling on tonsils</td>
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>	
							<tr>
								<td valign="top">Tender/swollen anterior or cervical lymph nodes</td>
								
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>	
							<tr>
								<td valign="top">Temperature above 38 degrees C (100.4 F)</td>
								
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>No</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>	
							<tr>
								<td valign="top">Cough</td>                
                <td valign="top" colspan="2">
                  <table>
                    <tr style="display:none;"><td colspan="2">Data</td></tr>
                    <tr>
                      <td>Present</td>
                      <td align="right">0</td>
                    </tr>
                    <tr>
                      <td>Absent</td>
                      <td align="right">+1</td>
                    </tr>
                  </table>
								</td>
							</tr>	
						</table>
						<h4 class="txt--xl">Interpreting Centor scores</h4>
						<table class="tbl table">
							<tr>
								<th valign="bottom" width="25%">Centor Score</th>
								<th valign="bottom" width="35%">Probability of strep pharyngitis </th>
								<th valign="bottom" width="40%">Recommendation</th>
							</tr>
							<tr>
								<td valign="top">
									0<br>1
								</td>
								<td valign="top">
									1-2.5%<br>5-10%
								</td>
								<td valign="top">
									No further testing or antibiotics. <br><br>Clinicians should also refer to local guidance when appropriate.
								</td>
							</tr>
							<tr>
								<td valign="top">
									2
								</td>
								<td valign="top">
									11-17%
								</td>
								<td valign="top">
                  Consider throat swab to help inform shared decision making about antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.
								</td>
							</tr>							
							<tr>
								<td valign="top">
									3
								</td>
								<td valign="top">
									28-35% 
								</td>
								<td valign="top">
									Consider throat swab to help inform shared decision making about antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.
								</td>
							</tr>				
							<tr>
								<td valign="top">
									>=4
								</td>
								<td valign="top">
									51-53% 
								</td>
								<td valign="top">
									Empiric antibiotics may be appropriate depending on the specific scenario. Consider throat swab to help inform shared decision making about antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.
								</td>
							</tr>
						</table>
					`,
        },
        {
          title: "Practice<span class='show--md'> considerations</span>",
          display: false,
          accordion: false,
          content: `
						<p>When applying the Centor score in practice, clinicians should be aware of the following points:</p>
						<h4 class="txt--lg">Diagnostic accuracy</h4>
						<p>A <a target="_blank" href="https://bmcmedicine.biomedcentral.com/articles/10.1186/1741-7015-9-67">2011 systematic review</a> of the diagnostic accuracy of the Centor score concluded that: </p>
						<p>Overall, as a decision rule for considering antibiotic prescribing (score ≥ 3), the Centor score has reasonable specificity (0.82, 95% CI 0.72 to 0.88) and a post-test probability of 12% to 40% based on a prior prevalence of 5% to 20%.</p>
						<p>The score is reasonably specific when ≥ 3 signs or symptoms are present (0.82) and very specific when 4 are present (0.95).</p>
						<p>The post-test probability of GABHS pharyngitis is relatively low (that is, for a prevalence of 15% and a score of ≥ 3, post-test probability is 32%</p>
						<p>The authors therefore recommend that, although the Centor score can enhance appropriate prescribing of antibiotics, it should be used with caution as treating all patients presenting with a sore throat and a score of ≥ 3 may lead to many patients being treated with antibiotics inappropriately.</p>
            <p><strong>Other considerations</strong></p>
            <p>Clinicians should be aware that the Centor criteria were developed in the US in an emergency department setting in 1981, and have only been validated in an adult population.</p>
            <p>Centor has only been validated in an adult population. However the risk of streptococcal infection decreases significantly with age into adulthood, and therefore the tool is most likely to be used with younger people.</p>
            <p>Young children (under 3 years) are unlikely to present with sore throat symptoms alone. <a href="https://www.nice.org.uk/guidance/ng84" target="_blank">NICE NG84 guidance</a> recommends that prescribers should follow the relevant guidelines on fever in under 5s to assess and manage fever in this population.</p>
            <p>The Centor criteria were developed in the US in an emergency department setting in 1981. Centor has not been validated in a UK population or in primary and community care settings.</p>
            <p>The <a href="https://www.nice.org.uk/guidance/ng84" target="_blank">NICE guideline NG84</a> overview of identifying people most likely to benefit from antibiotics includes a fuller comparison of Centor and FeverPain scoring systems.</p>
          `,
        }
      ]
    };
  },
  methods: {			
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) 
        {
          window.open(url,target);  
        }
        else{
          if(target == "_blank") {
            let data = {title:'',nodeid: dataId, href:url, target: target};
            window.Native('dataCallback', data);
          } 
        }	
      }
    },
		selectTab(selectedTab) {
			this.tabs.forEach(tab => {
				if(tab.display) {
					tab.display = false;
				} else {
					tab.display = (tab.title == selectedTab.title);
				}
			});
		},
    reset() {
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";
      this.result.score = 0;
      this.result.calctext = "";
      this.result.text = "";
      this.displayresult = false;
      this.showform = false;
      this.errormessage= "";
      this.emailmessage = "";
      this.isvalid= false;
      this.answered_count= 0;
      this.answer_acutechange= false;
      this.questions.forEach(q => {
        q.options.forEach(o => {
					o.selected = false;
				});
      });
    },
		displayForm(){		
      this.showform = !this.showform;
		},
    calculateclicked() {
      this.displayresult = true;
      this.showform = false;
			this.emailmessage	= "";
      this.emailaddresses = "";
      this.patientname = "";
      this.patientchinumber = "";
      if (this.answered_count < this.questions.length) {
        this.errormessage =  "<h2 class='txt--lg'>One or more inputs missing.</h2>";
				this.errormessage += "<p>Total Centor score cannot be calculated as one or more inputs are missing.</p>";
				this.errormessage += "<p>Required inputs are: Age, Tonsil exudate or swelling, Swollen lymph nodes, Temperature, Cough.</p>";
				this.errormessage += "<p>If 4 of the Centor criteria are met, PPV is 60%. The absence of 3 or 4 of the Centor criteria has a NPV of 80%.</p>";
				setTimeout(()=> {
					document.getElementById("error").scrollIntoView(true)},100);
      } else {
        this.errormessage = "";
      }
		},
    copyToClipboard() {
      var range;
      var finalText = "";
      if (document.selection) { // IE
        range = document.body.createTextRange();
        range.moveToElementText(document.getElementById('calculator-copy'));
        range.select();
        finalText = this.getDateToday() + "\n\nCentor Score (Modified, McIsaac) for Streptococcal Pharyngitis\n\n" + range + "\nEnter action taken as a result of this alert";
        document.selection.empty();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(document.getElementById('calculator-copy'));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        finalText = this.getDateToday() + "\n\nCentor Score (Modified, McIsaac) for Streptococcal Pharyngitis\n\n" + window.getSelection().toString() + "Enter action taken as a result of this alert";
        window.getSelection().removeAllRanges();
      }
      var dummy = document.createElement("textarea");
      // Add it to the document
      document.body.appendChild(dummy);

      // Set its ID
      dummy.setAttribute("id", "dummy_id");

      // Output the array into it
      document.getElementById("dummy_id").value = finalText;

      // Select it
      dummy.select();

      // Copy its contents
      document.execCommand("copy");

      // Remove it as its not needed anymore
      document.body.removeChild(dummy);

      var clicked = false;
      var copyButton = document.getElementById('copyButton');
      if (!clicked) {
            var last = copyButton.innerHTML;
            copyButton.innerHTML = 'Copied!';
            clicked = true;
            setTimeout(function () {
                copyButton.innerHTML = last;
                clicked = false;
            }.bind(copyButton), 5000);
        }
    },
    getDateToday() {
      var date = "";
      var today = new Date();
      date = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + " " + (today.getHours() < 10 ? "0" + today.getHours() : today.getHours()) + ":" + (today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes());
      return date;
    },
    sendToPDF() {
        // if (this.emailaddresses == "") {
        //     this.emailmessage = "You must supply at least one email address.";
        // }
        // else if (this.patientname == "") {
        //     this.emailmessage = "You must supply the patient's name.";
        // }
        // else if (this.patientchinumber == "") {
        //     this.emailmessage = "You must supply the patient CHI number."
				// }

				if (this.patientchinumber == "" || this.patientname == "" || this.patientchinumber == ""){
						this.emailmessage = "All fields are required."
				}
        else {
            var formToPost = {
                EmailAddresses: this.emailaddresses,
                PatientName: this.patientname,
                PatientChiNumber: this.patientchinumber,
                Questions: this.questions,
                Result: this.result,
                DisplayWarning: this.answered_count < this.questions.length,
            };

            var model = JSON.stringify(formToPost);

            fetch("/SoreThroat/GetCentorPDF", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: model
            })
                .then(response => response.text())
                .then(data => {
                    if (data.startsWith("Email Error: ")) {
                        this.emailmessage = data.replace("Email Error: ", "");
                        this.showform = true;
                    } else {
                        this.emailmessage = data;
                        this.showform = false;
                    }
                })
                .catch((error) => {
                    console.log('EMAIL ERROR', error);
                });
        }
    },
		anchorLink(i) {
			var element = document.getElementById(i);
			element.scrollIntoView();
			// console.log(element);
			// console.log(top);
			// window.scrollTo(0, top);
		},
		
    closedclicked() {
      this.displayresult = false;
    },
    optionclicked(qid, oid) {
      this.displayresult = false;
      let _score = 0;
      this.questions.forEach(q => {
        if (q.id === qid) {
          q.options.forEach(o => {
            if (o.id === oid) {
              if(o.selected)
              {
                o.selected = false;
              }
              else
              {
                o.selected = true;
              }
              
            } else {
              o.selected = false;
            }
          });
        }
      });
      let _cnt = 0;
      let _required_cnt = 0;
      let _required_answered_cnt = 0;
      this.answer_acutechange = false;
      this.questions.forEach(q => {
        if (q.required) {
          _required_cnt++;
        }
      });
      this.questions.forEach(q => {
        q.options.forEach(o => {
          if (o.selected) {
            _score += o.value;
            _cnt++;
          }
          if (o.selected && q.required) {
            _required_answered_cnt++;
          }
          // if (q.id === "q4") {
          //   if (o.selected) {
          //     this.answer_acutechange = true;
          //   }
          // }
        });
      });

      this.answered_count = _cnt;
      this.isvalid = _required_answered_cnt === _required_cnt ;
      if (this.isvalid) {
        this.errormessage = "";
      }
      this.result.score = _score;

      if (_score <= 0) {
				this.result.text = "Probability of strep pharyngitis 1-2.5%";
				this.result.subtext = "No further testing or antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.";
      }
      if (_score == 1) {
				this.result.text = "Probability of strep pharyngitis 5-10%";
				this.result.subtext = "No further testing or antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.";
			}
			if (_score == 2) {
				this.result.text = "Probability of strep pharyngitis 11-17%";
				this.result.subtext = "Consider throat swab to help inform shared decision making about antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.";
			}
			if (_score == 3) {
				this.result.text = "Probability of strep pharyngitis 28-35%";
				this.result.subtext = "Consider throat swab to help inform shared decision making about antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.";
			}
			if (_score >= 4) {
        this.result.text = "Probability of strep pharyngitis 51-53%";
				this.result.subtext = "Empiric antibiotics may be appropriate depending on the specific scenario. Consider throat swab to help inform shared decision making about antibiotics.<br><br>Clinicians should also refer to local guidance when appropriate.";
      }

      

      let _calctext = "";
      let _idx2 = 0;
      //let _len = this.questions.length;
      this.questions.forEach(q => {
        //_calctext = _calctext + q.title+": ";

        q.options.forEach(o => {
          if (o.selected) {
            if (_idx2 === 0) {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } else {
							_calctext = _calctext + "<strong>" + q.title + "</strong><br><span class='badge badge-success badge-pill'>"+ o.value_label + "</span>&nbsp;"+ o.text +"<br><br>";
            } 
          }
				});

        _idx2++;
      });
      
      this.result.calctext = _calctext;
    }
  }
};
</script>